module.exports = __webpack_public_path__ + "static/media/Bluelab Pro Controller Wi-Fi.049afe90.webp";